import React, { useState, useEffect } from 'react';

// Recursive component that renders a single comment and its nested replies.
const CommentItem = ({ comment, onReply, onDelete }) => {
  const [showReplyForm, setShowReplyForm] = useState(false);
  const [replyAuthor, setReplyAuthor] = useState('');
  const [replyEmail, setReplyEmail] = useState('');
  const [replyContent, setReplyContent] = useState('');

  const handleReplySubmit = (e) => {
    e.preventDefault();
    onReply(comment._id, {
      authorName: replyAuthor,
      authorEmail: replyEmail,
      content: replyContent,
    });
    setReplyAuthor('');
    setReplyEmail('');
    setReplyContent('');
    setShowReplyForm(false);
  };

  return (
    <li className={comment.parentComment ? "children mb-10 mt-10" : ""}>
      <div className="comments-box">
        <div className="comments-avatar">
          <img
            src="https://omsoftwares.in/assets/img/about/dpreview.webp"
            alt=""
          />
        </div>
        <div className="comments-text">
          <div className="avatar-name">
            <h5>{comment.authorName}</h5>
            <span>{new Date(comment.createdAt).toLocaleDateString()}</span>
            <a
              className="reply"
              href="#0"
              onClick={(e) => {
                e.preventDefault();
                setShowReplyForm(!showReplyForm);
              }}
            >
              Reply
            </a>
            <button
              onClick={() => onDelete(comment._id)}
              className='logout-button'
              style={{ marginLeft: '6px', fontSize: '0.8rem', border: 'none', padding: '2px 4px' }}
            >
              Delete
            </button>
          </div>
          <p>{comment.content}</p>
        </div>
      </div>
      {showReplyForm && (
        <div className="comments-form" style={{ marginLeft: '20px', marginTop: '10px' }}>
          <form onSubmit={handleReplySubmit} className="xb-item--form contact-from">
            <div className="row">
              <div className="col-lg-6">
                <div className="xb-item--field">
                  <input
                    type="text"
                    placeholder="Your Name"
                    value={replyAuthor}
                    onChange={(e) => setReplyAuthor(e.target.value)}
                    required
                  />
                </div>
              </div>
              <div className="col-lg-6">
                <div className="xb-item--field">
                  <input
                    type="email"
                    placeholder="Your Email"
                    value={replyEmail}
                    onChange={(e) => setReplyEmail(e.target.value)}
                    required
                  />
                </div>
              </div>
              <div className="col-12">
                <div className="xb-item--field">
                  <textarea
                    placeholder="Write Your Reply..."
                    value={replyContent}
                    onChange={(e) => setReplyContent(e.target.value)}
                    required
                  ></textarea>
                </div>
              </div>
              <div className="col-12">
                <button className="xb-btn" type="submit">
                  Submit Reply
                </button>
              </div>
            </div>
          </form>
        </div>
      )}
      {comment.replies && comment.replies.length > 0 && (
        <ul className="list-unstyled mb-0">
          {comment.replies.map((reply) => (
            <CommentItem key={reply._id} comment={reply} onReply={onReply} onDelete={onDelete} />
          ))}
        </ul>
      )}
    </li>
  );
};

const Comments = ({ urlHeading, setCommentCount }) => {
  const [comments, setComments] = useState([]);
  const [authorName, setAuthorName] = useState('');
  const [authorEmail, setAuthorEmail] = useState('');
  const [content, setContent] = useState('');
  const [totalCount, setTotalCount] = useState(0);
  const API_HOST = process.env.REACT_APP_API_URL;
  // Fetch comments from the backend using the provided urlHeading.
  const countComments = (comments) =>
    comments.reduce(
      (total, comment) =>
        total + 1 + (comment.replies ? countComments(comment.replies) : 0),
      0
    );
  const fetchComments = async () => {
    try {
      const res = await fetch(`${API_HOST}blogs/comments/show/${urlHeading}`);
      const data = await res.json();
      setComments(data);
      setTotalCount(countComments(data));
      setCommentCount(countComments(data));
    } catch (error) {
      console.error('Error fetching comments', error);
    }
  };





  useEffect(() => {
    fetchComments();
    
  }, [urlHeading]);

  // Submit a top-level comment.
  const handleSubmit = async (e) => {
    e.preventDefault();
    const commentData = { urlHeading, authorName, authorEmail, content, parentComment: null };
    try {
      await fetch(`${API_HOST}blogs/comments/create`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(commentData),
      });
      setAuthorName('');
      setAuthorEmail('');
      setContent('');
      fetchComments();
    } catch (error) {
      console.error('Error submitting comment', error);
    }
  };

  // Submit a reply.
  const handleReply = async (parentId, replyData) => {
    const data = { urlHeading, parentComment: parentId, ...replyData };
    try {
      await fetch(`${API_HOST}blogs/comments/create`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
      });
      fetchComments();
    } catch (error) {
      console.error('Error submitting reply', error);
    }
  };

  // Delete a comment.
  const handleDelete = async (commentId) => {
    const authToken = sessionStorage.getItem("authToken");
    try {
      await fetch(`${API_HOST}blogs/comments/delete/${commentId}`, { method: 'DELETE',
        headers: { "auth-token": authToken },
       });
     
      fetchComments();
    } catch (error) {
      console.error('Error deleting comment', error);
    }
  };

  return (
    <div className="row" id="comments">
      <div className="col-xl-12">
        <div className="post-comments">
          <h2 className="title mb-25">
            {/* {comments.length}  */}
            {totalCount} Comments</h2>
          <div className="latest__comments">
            <ul className="list-unstyled mb-0">
              {comments.map((comment) => (
                <CommentItem key={comment._id} comment={comment} onReply={handleReply} onDelete={handleDelete} />
              ))}
            </ul>
          </div>
        </div>
        <div className="comments-form">
          <div className="comment-heading">
            <h2 className="title">Post Comments</h2>
            <p>Your email address will not be published. Required fields are marked *</p>
          </div>
          <form className="xb-item--form contact-from" onSubmit={handleSubmit}>
            <div className="row">
              <div className="col-lg-6">
                <div className="xb-item--field">
                  <input
                    type="text"
                    placeholder="Your Name*"
                    value={authorName}
                    onChange={(e) => setAuthorName(e.target.value)}
                    required
                  />
                </div>
              </div>
              <div className="col-lg-6">
                <div className="xb-item--field">
                  <input
                    type="email"
                    placeholder="Your Email*"
                    value={authorEmail}
                    onChange={(e) => setAuthorEmail(e.target.value)}
                    required
                  />
                </div>
              </div>
              <div className="col-12">
                <div className="xb-item--field">
                  <textarea
                    name="message"
                    id="message"
                    cols="30"
                    rows="10"
                    placeholder="Write Your Comment...*"
                    value={content}
                    onChange={(e) => setContent(e.target.value)}
                    required
                  ></textarea>
                </div>
              </div>
              <div className="col-12">
                <button className="xb-btn" type="submit">
                  Post Comment
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Comments;
